
<template>
  <div>
    <Grid
      :service="service"
      defaultOrderColumn="created_date_formatted"
      defaultOrderDirection="asc"
      route_name="incident_form"
      :ref="'grid'"
      :css_formats="{
        validated_date_formatted: (name, model) => {
          if(name){
            return `badge badge-glow badge-${model.status_label_validated}`
          }else{
            return ''
          }
        }
      }"
    >
      <template v-slot:actions="actions">
        <div class="flex flex-row gap-2">
          <feather-icon
            v-permission="`incident_form.handling`"
            icon="CheckIcon"
            class="h-5 w-5 mb-1 mr-1 stroke-current text-success"
            v-tooltip.top="{
              content: 'Tratar formulário',
              delay: { show: 100, hide: 100 }
            }"
            @click="handling(actions.row.id)"
          />
          <feather-icon
            v-if="enableEditForm(actions.row.status)"
            v-permission="`request_form_incident.edit`"
            icon="EditIcon"
            class="h-5 w-5 mb-1 mr-1 stroke-current text-warning"
            v-tooltip.top="{
              content: 'Editar formulário aberto',
              delay: { show: 100, hide: 100 }
            }"
            @click="edit(actions.row.id)"
          />
          <feather-icon
            v-permission="`incident_form.detail`"
            icon="EyeIcon"
            class="h-5 w-5 mb-1 mr-1 stroke-current text-primary"
            v-tooltip.top="{
              content: 'Detalhar formulário',
              delay: { show: 100, hide: 100 }
            }"
            @click="detail(actions.row.id)"/>
          <!--
          <feather-icon
            v-permission="`incident_form.delete`"
            icon="Trash2Icon"
            class="h-5 w-5 mb-1 mr-1 stroke-current text-danger"
            v-tooltip.top="{
              content: 'Excluir formulário',
              delay: { show: 100, hide: 100 }
            }"
            @click="destroy(actions.row.id)"/>
            -->
        </div>
      </template>
    </Grid>
  </div>
</template>


<script>
import { BButton } from 'bootstrap-vue'

import IncidentFormHandlingService from '@/services/api/incident/RequestFormIncidentHandlingService'

export default {
  directives: {
  },
  components: {
    BButton,
  },
  data: () => ({
    selected: [],
    service: null
  }),
  methods: {
    grid() {
      return this.$refs['grid']
    },
    handling(id) {
      this.$router.push(`/incident-form/${id}/handling`)
    },
    edit(id) {
      this.$router.push(`/incident-form/${id}/edit`)
    },
    detail(id) {
      this.$router.push(`/incident-form/${id}`)
    },
    destroyModel(id) {
      this.$vs.loading()
      this.service.destroy(id).then(
        response => {
          this.notifySuccess(this.$vs, 'Registro excluído com sucesso!')
          this.grid().fetchGridData()
        },
        error => {
          this.notifyError(this.$vs, 'Não foi possível excluir o registro especificado')
        }
      ).finally(
        () => this.$vs.loading.close()
      )
    },
    destroy(id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'success',
        title: 'Confirmação',
        acceptText: 'Sim',
        cancelText: 'Não',
        text: 'Tem certeza que deseja excluir este registro?',
        accept: () => {
          this.destroyModel(id)
        }
      })
    },
    enableEditForm(status) {
      return (status === 'PE' || status === 'OP' || status === 'IV' || status === 'IH')
    }
  },
  beforeMount() {
    this.service = IncidentFormHandlingService.build(this.$vs)
  }
}
</script>
